module.exports = __webpack_public_path__ + "statics/img/earthwork-2-idcards.a2526f02.png";